import { TFunction } from 'i18next';

import { Button } from '../../../../components/buttons';
import { IPWAInstall } from '../../hooks';
import { ANDROIDLink } from '../AppLinks';
import { MobileAppCMSI } from '@/api/cms';

export enum MobileAppEnum {
  Android = 1,
  PWA = 2,
}

export const getStepsAndroid = (
  isMobileDevice: boolean,
  t: TFunction,
  mobileAppCMS: MobileAppCMSI | null
) => {
  return [
    ...(isMobileDevice
      ? [
          {
            description: t('new.android.step-1-mob'),
            component: (
              <ANDROIDLink
                onClick={() => {
                  if (!mobileAppCMS?.androidApk?.url) return;
                  window.open(mobileAppCMS.androidApk.url, '_blank');
                }}
              />
            ),
          },
        ]
      : [
          {
            description: t('new.android.step-1'),
            qrSrc: mobileAppCMS?.androidApk?.url,
          },
        ]),
    {
      description: t('new.android.step-2'),
      img: {
        src: '/mobile-app/android/sstep-2.png',
        width: isMobileDevice ? 142 : 119,
        height: isMobileDevice ? 300 : 250,
      },
    },
    {
      description: t('new.android.step-3'),
      img: {
        src: '/mobile-app/android/sstep-3.png',
        width: isMobileDevice ? 142 : 119,
        height: isMobileDevice ? 300 : 250,
      },
    },
    {
      description: t('new.android.step-4'),
      img: {
        src: '/mobile-app/android/sstep-4.png',
        width: isMobileDevice ? 142 : 119,
        height: isMobileDevice ? 300 : 250,
      },
    },
    {
      description: t('new.android.step-5'),
      img: {
        src: '/mobile-app/android/sstep-5.png',
        width: isMobileDevice ? 142 : 119,
        height: isMobileDevice ? 300 : 250,
      },
    },
    {
      description: t('new.android.step-6'),
      img: {
        src: '/mobile-app/android/sstep-6.png',
        width: isMobileDevice ? 142 : 119,
        height: isMobileDevice ? 300 : 250,
      },
    },
  ];
};

export const getStepsPWA1 = (isMobileDevice: boolean, t: TFunction) => {
  if (isMobileDevice) {
    return [
      {
        description: t('new.pwa.step-1-1-mob'),
        img: {
          src: '/mobile-app/web/step-1-1.webp',
          width: 156,
          height: 300,
        },
      },
      {
        description: t('new.pwa.step-1-2-mob'),
        img: {
          src: '/mobile-app/web/step-1-2.webp',
          width: 156,
          height: 300,
        },
      },
      {
        description: t('new.pwa.step-1-3-mob'),
        img: {
          src: '/mobile-app/web/step-1-3.webp',
          width: 156,
          height: 300,
        },
      },
    ];
  }
  return [
    {
      description: t('new.pwa.step-1-1'),
      qrSrc: window.location.host,
    },
    {
      description: t('new.pwa.step-1-2'),
      img: {
        src: '/mobile-app/web/step-1-1.webp',
        width: 168,
        height: 324,
      },
    },
    {
      description: t('new.pwa.step-1-3'),
      img: {
        src: '/mobile-app/web/step-1-2.webp',
        width: 168,
        height: 324,
      },
    },
    {
      description: t('new.pwa.step-1-4'),
      img: {
        src: '/mobile-app/web/step-1-3.webp',
        width: 168,
        height: 324,
      },
    },
  ];
};

export const getStepsPWA2 = (t: TFunction) => {
  return [
    {
      description: t('new.pwa.step-2-1'),
      img: {
        src: '/mobile-app/web/step-2-1.png',
        width: 238,
        height: 60,
      },
      className: 'step-2-1',
    },
    {
      description: t('new.pwa.step-2-2'),
      img: {
        src: '/mobile-app/web/step-2-2.png',
        width: 278,
        height: 50,
      },
      className: 'step-2-2',
    },
    {
      description: t('new.pwa.step-2-3'),
      img: {
        src: '/mobile-app/web/sstep-2-3.png',
        width: 320,
        height: 120,
      },
    },
  ];
};

export const getStepsPWA3 = (t: TFunction) => {
  return [
    {
      description: t('new.pwa.step-3-1'),
      img: {
        src: '/mobile-app/web/step-3-1.png',
        width: 238,
        height: 60,
      },
      className: 'step-3-1',
    },
    {
      description: t('new.pwa.step-3-2'),
      img: {
        src: '/mobile-app/web/step-3-2.png',
        width: 278,
        height: 50,
      },
      className: 'step-3-2',
    },
    {
      description: t('new.pwa.step-3-3'),
      img: {
        src: '/mobile-app/web/sstep-3-3.png',
        width: 320,
        height: 120,
      },
    },
  ];
};

export const getStepsAndroidPWA = (
  isMobileDevice: boolean,
  t: TFunction,
  pwaInstall: IPWAInstall
) => {
  return [
    ...(isMobileDevice
      ? [
          {
            description: t('new.androidPWA.step-1-mob'),
            component: (
              <Button
                onClick={pwaInstall.triggerInstall}
                primary
                large
                disable={!pwaInstall.isInstallable}
              >
                {t('new.androidPWA.step-1-mob-btn')}
              </Button>
            ),
          },
        ]
      : [
          {
            description: t('new.androidPWA.step-1'),
            qrSrc: window.location.host,
          },
          {
            description: t('new.androidPWA.step-2'),
            img: {
              src: '/mobile-app/androidPWA/step-22.webp',
              width: isMobileDevice ? 142 : 119,
              height: isMobileDevice ? 300 : 250,
            },
          },
        ]),
    {
      description: t('new.androidPWA.step-3'),
      img: {
        src: '/mobile-app/androidPWA/step-33.webp',
        width: isMobileDevice ? 142 : 119,
        height: isMobileDevice ? 300 : 250,
      },
    },
    {
      description: t('new.androidPWA.step-4'),
      img: {
        src: '/mobile-app/androidPWA/step-44.webp',
        width: isMobileDevice ? 142 : 119,
        height: isMobileDevice ? 300 : 250,
      },
    },
  ];
};
